import request from "./config";

export default class CodeService {
  static create(data) {
    return request({
      url: "/code",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/code/${id}`,
      method: "patch",
      data,
    });
  }
  static delete(id) {
    return request({
      url: `/code/${id}`,
      method: "delete",
    });
  }
  static  findAll(params) {
    return request({
      url: `/code`,
      method: "get",
      timeout: 100000,
      params:params
    });
  }
  static  find(params) {
    return request({
      url: `/code`,
      method: "get",
      timeout: 100000,
      params:params
    });
  }
  static  findUltimate(type) {
    return request({
      url: `/code/type/${type}`,
      method: "get",
      timeout: 100000,
    });
  }
}
